import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getSelection, COMMAND_PRIORITY_NORMAL, PASTE_COMMAND } from 'lexical';
import { $insertDataTransferForRichText } from '@lexical/clipboard';
export default function GoogleDocsPastePlugin() {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        return editor.registerCommand(PASTE_COMMAND, (event) => {
            var _a, _b, _c;
            if (!(event instanceof ClipboardEvent)) {
                return false;
            }
            const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
            if (!html) {
                return false;
            }
            const selection = $getSelection();
            if (!selection) {
                return false;
            }
            const googleDocRegex = /<b.* id="docs-internal-guid-\S*">/i;
            if (!googleDocRegex.test(html)) {
                return false;
            }
            let cleaned = html.replace(googleDocRegex, '');
            cleaned = cleaned.replace('</b>', '');
            const plain = (_c = (_b = event.clipboardData) === null || _b === void 0 ? void 0 : _b.getData('text/plain')) !== null && _c !== void 0 ? _c : '';
            const dataTransferShim = {
                getData: (type) => (type === 'text/html' ? cleaned : plain),
                types: ['text/html', 'text/plain'],
            };
            event.preventDefault();
            $insertDataTransferForRichText(dataTransferShim, selection, editor);
            return true;
        }, COMMAND_PRIORITY_NORMAL);
    }, [editor]);
    return null;
}
